/* eslint-disable */
export default {
  matched: '一致',
  other: 'その他',
  associated: '関連付け済み',
  foundFromServer: '{appName}での検索結果',
  recently: '履歴',
  additionalLabelAccount: 'アカウント：{displayName}',
  additionalLabelContact: '連絡先：{displayName}',
  notFound: '該当なし',
} as const;

// @key: @#@"matched"@#@ @source: @#@"Matched"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"associated"@#@ @source: @#@"Associated"@#@
// @key: @#@"foundFromServer"@#@ @source: @#@"Found from {appName}"@#@
// @key: @#@"recently"@#@ @source: @#@"Recent"@#@
// @key: @#@"additionalLabelAccount"@#@ @source: @#@"Account: {displayName}"@#@
// @key: @#@"additionalLabelContact"@#@ @source: @#@"Contact: {displayName}"@#@
// @key: @#@"notFound"@#@ @source: @#@"N/A"@#@
